if (!customElements.get('wlsn-accessories-buybox')) {
  class WLSNAccessoriesBuybox extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        activeClass: 'is-active',
        disabledClass: 'disabled',
        quantityIncrease: 'js-wlsn-accessories-buybox-qty-btn-increase',
        quantityDecrease: 'js-wlsn-accessories-buybox-qty-btn-decrease',
        quantityInput: 'js-wlsn-accessories-buybox-quantity-input',
        quantityAtc: 'js-wlsn-accessories-buybox-atc',
        sellingPlan: 'js-wlsn-accessories-buybox-selling-plan',
        selectedSellingPlan: 'js-wlsn-accessories-buybox-selling-plan.is-active',
        buyboxButtonWrapper: 'js-wlsn-accessories-buybox-button-wrapper',
        variantOption: 'js-wlsn-accessories-buybox-variant-option',
        variantImage: 'js-wlsn-accessories-buybox-variant-image',
        productPrice: 'js-wlsn-accessories-buybox-price',
        variantsWrapper: 'js-wlsn-accessories-buybox-variants',
        sellingPlanInput: 'input[name="selling_plan"]',
        gallerySlider: 'js-wlsn-slider',
        galleryImage: 'wlsn-accessories-buybox__slider-img',
        stickyCta: 'wlsn-sticky-cta',
        stickyCtaVariant: 'js-wlsn-sticky-cta-variant',
        subtitle: 'js-wlsn-accessories-buybox-subtitle',
        subtitleReadMore: 'js-wlsn-accessories-buybox-subtitle-read-more',
        subtitleWrapper: 'wlsn-accessories-buybox__subtitle',
        variantData: 'js-wlsn-accessories-buybox-data',
        optionTitle: 'js-wlsn-accessories-buybox-option-title',
        planPrice: 'js-wlsn-accessories-buybox-plan-price',
        planCompare: 'js-wlsn-accessories-buybox-plan-compare',
        planBadge: 'js-wlsn-accessories-buybox-plan-badge',
        productId: 'js-product-id',
        stickyCtaButton: 'js-wlsn-product-cta'
      };

      this.setElements();
      this.variantData = this.getVariantData();

      this.drawer;

      const selectedPurchaseOption = this.querySelector(
        'input[name="Bundle & Save"]:checked'
      );

      if (selectedPurchaseOption) {
        this.updateSellingPlanTitle(selectedPurchaseOption);
      }
      
      this.selectedState = {
        optionId: this.getSelectedVariantOptionIds() || null,
        quantityId: selectedPurchaseOption?.dataset.sellingPlanId ?? ''
      };
    }

    getSelectedVariantOptionIds() {
      return Array.from(this.querySelectorAll(`.${this.classes.variantOption}:checked`))
        .map((input) => input.value)
        .filter(Boolean)
        .join(',');
    }

    onVariantOptionChange = (e) => {
      const input = e.target;
    
      if (
        !input.matches?.(`.${this.classes.variantOption}`) ||
        input.type !== 'radio' ||
        !input.checked
      ) {
        return;
      }
    
      const sellingPlanId = input.dataset.sellingPlanId;
      this.updateSellingPlanTitle(input);
    
      this.selectedState.quantityId = sellingPlanId || null;
    
      if (this.elements.sellingPlanInput) {
        this.elements.sellingPlanInput.value = sellingPlanId || '';
      }

      if (input.name === 'Bundle & Save') {
        this.updateStickyCTAPrice(input);
      }

      if (input.name === 'Hearing Aid Model') {
        this.filterGalleryByModel(input);
        this.syncGalleryWithSelectedVariant();
      }
    
      this.selectedState.optionId = this.getSelectedVariantOptionIds() || null;
      this.updateVariants();
      this.updateURL();
    };

    connectedCallback() {
      if (!this._variantChangeBound) {
        this._variantChangeBound = true;
        this.addEventListener('change', this.onVariantOptionChange);
      }

      this.init();
      this.drawer = document.querySelector('wlsn-cart-drawer');
      this.syncGalleryWithSelectedVariant();

      const selectedInput = this.querySelector(
        '.js-wlsn-accessories-buybox-variant-option:checked'
      );
      
      if (selectedInput?.dataset.sellingPlanId && this.elements.sellingPlanInput) {
        this.elements.sellingPlanInput.value =
          selectedInput.dataset.sellingPlanId;
      }

      const selectedModel = this.querySelector(
        'input[name="Hearing Aid Model"]:checked'
      );
      
      if (selectedModel) {
        this.filterGalleryByModel(selectedModel);
      }

      this.updateVariants();
    }

    disconnectedCallback() {
      if (this._pageShowBound) {
        window.removeEventListener('pageshow', this.handlePageShow);
        this._pageShowBound = false;
      }

      if (this._variantChangeBound) {
        this.removeEventListener('change', this.onVariantOptionChange);
        this._variantChangeBound = false;
      }
    }

    init() {
      this.setupQuantityButtons();
      this.setupAddToCart();
      this.handleEventListeners();
      this.setupSubtitleReadMore();

      const purchaseOptionSelected = !!this.querySelector(
        'input[name="Bundle & Save"]:checked'
      );
      
      if (
        this.elements.variantOptions.length > 0 &&
        (!this.selectedState.optionId || !purchaseOptionSelected)
      ) {
        this.disableBuyboxButtonWrapper();
      }

      if (!this._pageShowBound) {
        this._pageShowBound = true;
        window.addEventListener('pageshow', this.handlePageShow);
      }
    }

    handlePageShow = (event) => {
      // Only needed when the page is restored from bfcache with a different radio state.
      if (!event.persisted) return;

      const selected = this.getSelectedVariantOptionIds();

      if (!selected) return;

      this.selectedState.optionId = selected;
      this.syncGalleryWithSelectedVariant();
      this.updateVariants();
    };

    handleEventListeners() {
      if (
        this.elements.subtitleReadMore &&
        this.elements.subtitleReadMore.dataset.wlsnAccessoriesBuyboxBound !== 'true'
      ) {
        this.elements.subtitleReadMore.dataset.wlsnAccessoriesBuyboxBound = 'true';
      
        this.elements.subtitleReadMore.addEventListener(
          'click',
          this.handleSubtitleReadMoreClick
        );
      }

      this.elements.sellingPlans.forEach(plan => {
        if (plan.dataset.wlsnAccessoriesBuyboxBound === 'true') return;

        plan.dataset.wlsnAccessoriesBuyboxBound = 'true';

        plan.addEventListener('click', () => {
          this.elements.sellingPlans.forEach(el => {
            el.classList.remove(this.classes.activeClass);
          });


          plan.classList.add(this.classes.activeClass);
          plan.checked = true;
          this.selectedState.quantityId = plan.dataset.optionId;
        });
      });
    }

    setupQuantityButtons() {
      if (this.elements.quantityIncrease && this.elements.quantityIncrease.dataset.wlsnAccessoriesBuyboxBound !== 'true') {
        this.elements.quantityIncrease.dataset.wlsnAccessoriesBuyboxBound = 'true';
        this.elements.quantityIncrease.addEventListener('click', () => this.changeQuantity(1));
      }

      if (this.elements.quantityDecrease && this.elements.quantityDecrease.dataset.wlsnAccessoriesBuyboxBound !== 'true') {
        this.elements.quantityDecrease.dataset.wlsnAccessoriesBuyboxBound = 'true';
        this.elements.quantityDecrease.addEventListener('click', () => this.changeQuantity(-1));
      }
    }

    changeQuantity(delta) {
      const currentValue = parseInt(this.elements.quantityInput.value, 10) || 1;
      const newValue = Math.max(1, currentValue + delta);

      this.elements.quantityInput.value = newValue;

      if (this.elements.quantityAtc) {
        this.elements.quantityAtc.dataset.quantity = newValue;
      }

      this.updateStickyCTA();
    }

    setupAddToCart() {
      if (!this.elements.quantityAtc || this.elements.quantityAtc.dataset.wlsnAccessoriesBuyboxBound === 'true') return;

      this.elements.quantityAtc.dataset.wlsnAccessoriesBuyboxBound = 'true';

      this.elements.quantityAtc.addEventListener('click', async (e) => {
        e.preventDefault();

        if (this.elements.buyboxButtonWrapper?.classList.contains(this.classes.disabledClass)) return;

        const data = {
          id: this.elements.quantityAtc.dataset.id,
          quantity: this.elements.quantityAtc.dataset.quantity || 1,
          selling_plan: this.elements.sellingPlanInput?.value || null
        };

        try {
          const addResponse = await fetch(`${window.location.origin}/cart/add.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
          });
        
          if (!addResponse.ok) {
            console.error('Add to cart failed:', addResponse);
            return;
          }
        
          if (window.cartType === 'cart_drawer') {
            this.drawer?.openDrawer();
            this.drawer?.setLoading(true);
            await this.drawer?.refreshDrawer();
            return;
          }
        
          window.location.href = window.location.origin + '/checkout?skip_shop_pay=true';
        } catch (err) {
          console.error('ATC error:', err);
        }
      });
    }

    getOptionValuesQuery() {
      return this.selectedState.optionId;
    }

    getVariantData() {
      const script = this.querySelector(`.${this.classes.variantData}`);

      if (!script) return null;

      try {
        return JSON.parse(script.textContent);
      } catch (err) {
        console.error('Invalid buybox variant data:', err);
        return null;
      }
    }

    // Returns the option value names for the given option value ids, ordered by product option position
    getOptionNamesFromIds(ids) {
      const names = [];

      ids.forEach((id) => {
        this.variantData.options.forEach((option, index) => {
          const value = option.values.find((v) => String(v.id) === String(id));
          if (value) names[index] = value.name;
        });
      });

      return names;
    }

    findVariantByOptionNames(names) {
      if (names.length !== this.variantData.options.length) return null;

      return this.variantData.variants.find((variant) =>
        variant.options.every((name, index) => name === names[index])
      ) || null;
    }

    // Variant for the current selection with one option value swapped out.
    // Options that aren't selected yet match any value, preferring an available variant.
    findVariantWithValue(input) {
      const ids = Array.from(this.querySelectorAll(`.${this.classes.variantOption}:checked`))
        .filter((checked) => checked.name !== input.name)
        .map((checked) => checked.value);

      ids.push(input.value);

      const names = this.getOptionNamesFromIds(ids);
      const matches = this.variantData.variants.filter((variant) =>
        variant.options.every((name, index) => names[index] === undefined || name === names[index])
      );

      return matches.find((variant) => variant.available) || matches[0] || null;
    }

    getLabel(input) {
      return this.querySelector(`label[for="${this.escapeSelector(input.id)}"]`);
    }

    updateVariants() {
      if (!this.variantData) return;

      const checkedInputs = Array.from(this.querySelectorAll(`.${this.classes.variantOption}:checked`));
      const variant = this.findVariantByOptionNames(
        this.getOptionNamesFromIds(checkedInputs.map((input) => input.value))
      );

      this.elements.variantOptions.forEach((input) => {
        const label = this.getLabel(input);
        const optionVariant = this.findVariantWithValue(input);

        label?.classList.toggle(this.classes.activeClass, input.checked);
        label?.classList.toggle('is-disabled', !optionVariant?.available);

        if (input.name === 'Bundle & Save') {
          this.updatePurchaseOption(input, label, optionVariant);
        }
      });

      this.querySelectorAll(`.${this.classes.optionTitle}`).forEach((title) => {
        const group = title.closest('.wlsn-accessories-buybox__variants-group');
        const checked = group?.querySelector(`.${this.classes.variantOption}:checked`);

        if (checked?.dataset.valueName) {
          title.textContent = checked.dataset.valueName;
        }
      });

      const purchaseOption = this.querySelector('input[name="Bundle & Save"]:checked');

      if (purchaseOption) {
        this.updateSellingPlanTitle(purchaseOption);
      }

      if (!variant) {
        this.disableBuyboxButtonWrapper();
        return;
      }

      this.querySelectorAll(`.${this.classes.productId}`).forEach((input) => {
        input.value = variant.id;
      });

      if (this.elements.quantityAtc) {
        this.elements.quantityAtc.dataset.id = variant.id;
      }

      this.updatePrice(variant);
      this.syncSellingPlanOnLoad();
      this.updateStickyCTA();
      this.updateStickyCTAVariant(variant);

      const allOptionsSelected = checkedInputs.length === this.variantData.options.length;

      this.elements.buyboxButtonWrapper?.classList.toggle(
        this.classes.disabledClass,
        !allOptionsSelected || !variant.available
      );
    }

    updatePurchaseOption(input, label, variant) {
      if (!variant) return;

      const isOneTime = !!label?.classList.contains('js-wlsn-accessories-buybox-selling-plan-one-time');
      const price = isOneTime ? variant.oneTimePrice : variant.planPrice;
      const comparePrice = isOneTime ? variant.oneTimeComparePrice : variant.planComparePrice;

      if (!isOneTime) {
        input.dataset.sellingPlanId = variant.sellingPlanId || '';
      }

      input.dataset.price = price;
      input.dataset.comparePrice = comparePrice;

      if (!label) return;

      const priceEl = label.querySelector(`.${this.classes.planPrice}`);
      const compareEl = label.querySelector(`.${this.classes.planCompare}`);
      const badgeEl = label.querySelector(`.${this.classes.planBadge}`);

      if (priceEl) priceEl.textContent = price;

      if (compareEl) {
        compareEl.textContent = comparePrice;
        compareEl.parentElement.hidden = !comparePrice;
      }

      if (badgeEl) {
        badgeEl.textContent = `Save ${variant.planDiscount}%`;
        badgeEl.hidden = !(variant.planDiscount > 0);
      }
    }

    updatePrice(variant) {
      const priceEl = this.elements.productPrice;

      if (!priceEl) return;

      priceEl.textContent = '';

      if (variant.comparePrice) {
        const compare = document.createElement('s');
        compare.textContent = variant.comparePrice;
        priceEl.append(compare, ' ');
      }

      const priceText = this.variantData.priceText ? `/${this.variantData.priceText}` : '';
      priceEl.append(`${variant.price}${priceText}`);
    }

    syncGalleryWithSelectedVariant() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const selectedInput = this.querySelector(`.${this.classes.variantOption}:checked`);

          if (!selectedInput) return;

          this.setActiveGalleryImageFromVariantInput(selectedInput);
        });
      });
    }

    setActiveGalleryImageFromVariantInput(input, attempt = 0) {
      const label = this.querySelector(`label[for="${this.escapeSelector(input.id)}"]`);
      const variantImage = label?.querySelector(`.${this.classes.variantImage}`);

      if (!variantImage) return;

      const variantFileName = this.getImageFileName(variantImage);

      if (!variantFileName) return;

      const galleryImages = Array.from(this.querySelectorAll(`.${this.classes.galleryImage}`));

      const matchedImage = galleryImages.find(image => {
        const galleryFileName = this.getImageFileName(image);

        return galleryFileName && galleryFileName === variantFileName;
      });

      if (!matchedImage) return;

      const matchedSlide = matchedImage.closest('.swiper-slide');

      if (!matchedSlide) return;

      const gallerySlider = matchedSlide.closest(`.${this.classes.gallerySlider}`);
      const swiper = gallerySlider?.swiper;

      if (!swiper) {
        if (attempt < 20) {
          requestAnimationFrame(() => {
            this.setActiveGalleryImageFromVariantInput(input, attempt + 1);
          });
          return;
        }

        matchedSlide.classList.add(this.classes.activeClass);
        matchedSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        return;
      }

      const slideIndex = Array.from(swiper.slides).indexOf(matchedSlide);

      if (slideIndex < 0) return;

      if (swiper.params?.loop && typeof swiper.slideToLoop === 'function') {
        const realIndex = Number(matchedSlide.dataset.swiperSlideIndex);

        if (!Number.isNaN(realIndex)) {
          swiper.slideToLoop(realIndex);
          return;
        }
      }

      swiper.slideTo(slideIndex);
    }

    getImageFileName(image) {
      const imageUrl =
        image.currentSrc ||
        image.src ||
        this.getFirstSrcFromSrcset(image.srcset);

      if (!imageUrl) return null;

      try {
        const url = new URL(imageUrl, window.location.origin);
        const pathname = decodeURIComponent(url.pathname);
        const fileName = pathname.split('/').pop();

        if (!fileName) return null;

        return fileName
          .replace(/\.(jpg|jpeg|png|webp|gif|avif)(\?.*)?$/i, '')
          .replace(/_(\d+)x(\d+|progressive)?(@2x)?$/i, '')
          .replace(/_\d+x$/i, '')
          .toLowerCase();
      } catch (err) {
        return imageUrl
          .split('?')[0]
          .split('/')
          .pop()
          ?.replace(/\.(jpg|jpeg|png|webp|gif|avif)$/i, '')
          .replace(/_(\d+)x(\d+|progressive)?(@2x)?$/i, '')
          .replace(/_\d+x$/i, '')
          .toLowerCase() || null;
      }
    }

    filterGalleryByModel(input) {
      if (!input || input.name !== 'Hearing Aid Model') return;
    
      // Slides are tagged with the raw option value, not the variant short name
      const modelName = (input.dataset.optionValue || input.dataset.valueName)?.trim();
      if (!modelName) return;
    
      const slides = Array.from(
        this.querySelectorAll('.wlsn-accessories-buybox__slide')
      );
    
      slides.forEach((slide) => {
        const slideModel = slide.dataset.valueName?.trim();
    
        slide.classList.toggle(
          'is-hidden',
          slideModel !== modelName
        );
      });
    
      const gallerySlider = this.querySelector(
        `.${this.classes.gallerySlider}`
      )?.swiper;
    
      if (gallerySlider) {
        gallerySlider.update();
        gallerySlider.slideTo(0, 0);
      }
    }

    getFirstSrcFromSrcset(srcset) {
      if (!srcset) return null;

      return srcset
        .split(',')
        .map(src => src.trim().split(' ')[0])
        .filter(Boolean)[0] || null;
    }

    escapeSelector(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }

      return value.replace(/"/g, '\\"');
    }

    updateURL() {
      const query = this.getOptionValuesQuery();
      const params = new URLSearchParams(window.location.search);
    
      params.delete('selling_plan');
    
      if (query) {
        params.set('option_values', query);
      } else {
        params.delete('option_values');
      }
    
      const queryString = params.toString();
      const newUrl = queryString
        ? `${window.location.pathname}?${queryString}`
        : window.location.pathname;
    
      window.history.replaceState({}, '', newUrl);
    }

    disableBuyboxButtonWrapper() {
      this.elements.buyboxButtonWrapper?.classList.add(this.classes.disabledClass);
    }

    syncSellingPlanOnLoad() {
      const input = this.querySelector('input[name="Bundle & Save"]:checked');
      const hidden = this.querySelector('input[name="selling_plan"]');
    
      if (hidden) {
        hidden.value = input?.dataset.sellingPlanId || '';
      }

      const selectedPurchaseOption = this.querySelector(
        'input[name="Bundle & Save"]:checked'
      );
      
      if (selectedPurchaseOption) {
        this.updateStickyCTAPrice(selectedPurchaseOption);
      }
    }

    updateSellingPlanTitle(input) {
      const title = input.dataset.displayTitle;
    
      const element = this.querySelector(
        '.js-selling-plan-title .wlsn-accessories-buybox__variants-title-selected'
      );
    
      if (element && title) {
        element.textContent = title;
      }
    }
    updateStickyCTA() {
      const sticky = this.elements.stickyCta;
      if (!sticky) return;
    
      const stickyButton = sticky.querySelector(`.${this.classes.stickyCtaButton}`);
    
      const variantId = this.elements.quantityAtc?.dataset.id;
      const quantity = this.elements.quantityAtc?.dataset.quantity || 1;
      const sellingPlanId = this.elements.sellingPlanInput?.value;
    
      if (variantId && stickyButton) {
        // id:qty:selling_plan is the format wlsn-checkout-link-handler-v2.js parses
        let href = `/cart/${variantId}:${quantity}`;
    
        if (sellingPlanId) {
          href += `:${sellingPlanId}`;
        }
    
        stickyButton.href = href;
      }
    }

    updateStickyCTAVariant(variant) {
      const stickyVariant = this.elements.stickyCtaVariant;
    
      if (stickyVariant && variant) {
        stickyVariant.textContent = variant.title;
      }
    }

    setupSubtitleReadMore() {
      const { subtitle, subtitleReadMore } = this.elements;
    
      if (!subtitle || !subtitleReadMore) return;
    
      const limit = 130;
      const fullText = subtitle.textContent.trim();
    
      if (fullText.length <= limit) {
        subtitleReadMore.hidden = true;
        return;
      }
    
      subtitle.dataset.fullText = fullText;
      subtitle.dataset.truncatedText = fullText.slice(0, limit).trim();
    
      subtitle.textContent = subtitle.dataset.truncatedText;
    
      subtitleReadMore.hidden = false;
      subtitleReadMore.textContent = 'Read more';
    }

    handleSubtitleReadMoreClick = (event) => {
      const button = event.currentTarget;
      const subtitle = this.elements.subtitle;
    
      if (!subtitle) return;
    
      const isExpanded = subtitle.classList.toggle(this.classes.activeClass);
    
      subtitle.textContent = isExpanded
        ? subtitle.dataset.fullText
        : subtitle.dataset.truncatedText;
    
      button.textContent = isExpanded ? 'Read less' : 'Read more';
    };

    updateStickyCTAPrice(input) {
      const sticky = this.elements.stickyCta;
    
      if (!sticky || !input) return;
    
      const price = input.dataset.price;
      const comparePrice = input.dataset.comparePrice;
    
      const stickyPrice = sticky.querySelector(
        '.js-wlsn-sticky-cta-price'
      );
    
      const stickyCompare = sticky.querySelector(
        '.js-wlsn-product-price-strikethrough'
      );
    
      if (stickyPrice && price) {
        stickyPrice.textContent = price;
      }
    
      if (stickyCompare) {
        stickyCompare.textContent = comparePrice || '';
      }
    }
    

    setElements() {
      this.elements = {
        quantityIncrease: this.querySelector(`.${this.classes.quantityIncrease}`),
        quantityDecrease: this.querySelector(`.${this.classes.quantityDecrease}`),
        quantityInput: this.querySelector(`.${this.classes.quantityInput}`),
        quantityAtc: this.querySelector(`.${this.classes.quantityAtc}`),
        sellingPlans: this.querySelectorAll(`.${this.classes.sellingPlan}`),
        selectedSellingPlan: this.querySelector(`.${this.classes.selectedSellingPlan}`),
        buyboxButtonWrapper: this.querySelector(`.${this.classes.buyboxButtonWrapper}`),
        variantOptions: this.querySelectorAll(`.${this.classes.variantOption}`),
        productPrice: this.querySelector(`.${this.classes.productPrice}`),
        sellingPlanInput: this.querySelector(`${this.classes.sellingPlanInput}`),
        stickyCta: this.querySelector(`.${this.classes.stickyCta}`),
        stickyCtaVariant: this.querySelector(`.${this.classes.stickyCtaVariant}`),
        subtitle: this.querySelector(`.${this.classes.subtitle}`),
        subtitleReadMore: this.querySelector(`.${this.classes.subtitleReadMore}`)
      };
    }
  }

  customElements.define('wlsn-accessories-buybox', WLSNAccessoriesBuybox);
}